import React from 'react';
import '../styles/About.css';

const About = () => {
  const stats = [
    { number: '50+', label: 'Projects Completed' },
    { number: '25+', label: 'Happy Clients' },
    { number: '5+', label: 'Years Experience' },
    { number: '24/7', label: 'Support Available' }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Tallhaven</h2>
            <p className="about-description">
              Founded with a vision to revolutionize the software development landscape, 
              Tallhaven has grown from a small startup to a trusted partner for businesses 
              seeking innovative digital solutions.
            </p>
            <p className="about-description">
              Our team of experienced developers, designers, and project managers work 
              collaboratively to deliver high-quality software that drives business growth 
              and enhances user experiences.
            </p>
            
            <div className="about-features">
              <div className="feature">
                <h4>Innovation First</h4>
                <p>We stay ahead of technology trends to deliver cutting-edge solutions.</p>
              </div>
              <div className="feature">
                <h4>Quality Assured</h4>
                <p>Rigorous testing and quality control ensure reliable, bug-free software.</p>
              </div>
              <div className="feature">
                <h4>Client-Focused</h4>
                <p>Your success is our priority. We work closely with you throughout the process.</p>
              </div>
            </div>
          </div>
          
          <div className="about-stats">
            <h3>Our Track Record</h3>
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;